import React, { useState, FC } from 'react';
import nanoid from 'nanoid';
import cn from 'classnames';
import getImgSrcWithPrefix from 'utils/getImgSrcWithPrefix';
import useMiniCard from 'hooks/useMiniCard';
import { useStores } from 'hooks/useStores';
import { observer } from 'mobx-react-lite';
import {
  MultiplePrewievStyles,
  MultipleContainer,
  MultipleItem,
  Pointer,
  LastMessage,
} from './MultiplePrewievStyles';

interface Props {
  photos: string[];
}

const MultiplePrewiev: FC<Props> = observer(({ photos }) => {
  const {
    appStore: { isMobile, isDesktop, isLaptop },
  } = useStores();

  const {
    display: { isHovered: isHoveredCard },
  } = useMiniCard();

  const [activePreview, setActivePreview] = useState(0);
  const resetActivePreview = () => setActivePreview(0);
  const currentUrl = photos?.[activePreview];
  const currentSizeImg = isMobile ? 'md' : 'sm';
  const countPrewiews = 5;
  const lastPrewiewIndex = countPrewiews - 1;
  const hasOtherPhotos = photos.length - countPrewiews > 0;

  const renderMultiplePrewiev = () => {
    if (photos.length < 2) return null;

    return (
      <MultipleContainer>
        {photos.slice(0, countPrewiews).map((_item, i) => {
          return (
            <MultipleItem
              onMouseEnter={() => setActivePreview(i)}
              onMouseLeave={resetActivePreview}
              key={nanoid()}
            >
              <Pointer className={cn(activePreview === i && 'active')} />
            </MultipleItem>
          );
        })}
        {hasOtherPhotos && (
          <LastMessage className={cn(activePreview === lastPrewiewIndex && 'show')}>
            Ещё {photos.length - countPrewiews} фото
          </LastMessage>
        )}
      </MultipleContainer>
    );
  };

  return (
    <MultiplePrewievStyles onMouseLeave={resetActivePreview}>
      <img src={getImgSrcWithPrefix(currentUrl, currentSizeImg)} alt="Truckmarket" />
      {(isDesktop || isLaptop) && isHoveredCard && renderMultiplePrewiev()}
    </MultiplePrewievStyles>
  );
});

export default MultiplePrewiev;
